import React, { useEffect, useMemo, useRef } from 'react';
import resumeData from '../data/resumeData.json';

const Skills = ({ data = resumeData.skills }) => {
  const progressBarsRef = useRef([]);
  const items = useMemo(() => data.items || [], [data.items]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const progressBar = entry.target;
            const percent = progressBar.getAttribute('data-percent');
            progressBar.style.width = percent + '%';
            progressBar.classList.add('in-view');
          }
        });
      },
      { threshold: 0.5 }
    );

    progressBarsRef.current.forEach((bar) => {
      if (bar) observer.observe(bar);
    });

    return () => observer.disconnect();
  }, [items]);

  return (
    <section className="o-section t-section">
      <div className="o-section__header-bg t-section__header"></div>
      <div className="o-section__content-bg t-section__content"></div>

      <div className="o-container">
        <div className="o-section__container">
          <header className="o-section__header t-section__header">
            <div className="o-content">
              <h2 className="o-section__heading">{data.heading}</h2>
              <div className="o-content__body o-section__description">{data.description}</div>
            </div>
          </header>

          <div className="o-section__content t-section__content">
            <div className="o-grid">
              {items.map((skill, index) => (
                <div className="o-grid__col-sm-6" key={skill.id}>
                  <div className="o-content">
                    <div className="o-media o-media--block">
                      <div className="o-media__figure">
                        <div className="c-number t-primary-color">
                          {skill.percent}
                          <small>%</small>
                        </div>
                      </div>
                      <div className="o-media__body">
                        <h3>{skill.name}</h3>
                      </div>
                    </div>
                    <div className="c-progress-bar o-content__body t-border-color-bg u-mt-text">
                      <div
                        ref={(el) => {
                          progressBarsRef.current[index] = el;
                        }}
                        className="a-progress-bar c-progress-bar__filler t-primary-bg"
                        data-percent={skill.percent}
                      ></div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
